<template>
  <v-app>
    <Menu></Menu>
    <router-view/>
    <Footer></Footer>
  </v-app>
</template>

<script>
import Menu from './components/Menu.vue';
import Footer from './components/Footer.vue';
export default {
  name: 'App',
  components: { Menu, Footer },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/profile')
      }
    }
  },
  computed: {
      user () {
        return this.$store.getters.user
      },
    },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.activo a{
  color:red;
}
</style>



// WEBPACK FOOTER //
// src/App.vue